<template>
  <section id="about" class="about mt-150 mb-50">

		<div class="container">
			<div class="row center">
				<div class="col-md-12">
					<div class="km-space"></div>
					<h5 class="lead">I'm a software engineer with full-stack expertise, building scalable systems from the database layer up to polished user interfaces. I care as much about clean architecture and reliable APIs as I do about performance and user experience.</h5>
				</div>
			</div><!-- description text -->
		</div>
        <div class="section-title-parralax">
						<div style="text-align: center;" class="process-numbers">WHO</div>
						<h2 style="text-align: center;">Who am i</h2>

					</div>
          <div class="hero-container">
                <div class="about-container">
                  <div class="terminal">
                    <div class="terminal-header">
                      <div class="header-button red"></div>
                      <div class="header-button yellow"></div>
                      <div class="header-button green"></div>
                    </div>
                    <div class="terminal-window">
                      <div>
                        <div class="statement">
                          <div class="input-statement">Malaika.currentLocation</div>
                          <div class="return-statement">"Orlando, FL"</div>
                        </div>
                        <div class="statement">
                          <div class="input-statement">Malaika.contactInfo</div>
                          <div class="return-statement">["<a href="mailto:malaika787@me.com">malaika787@me.com</a>", "<a href="https://www.linkedin.com/in/malaika-kunle-3b7861b6/" target="_blank">LinkedIn</a>", "<a href="https://github.com/malaika787" target="_blank">github</a>"]</div>
                        </div>
                        <div class="statement">
                          <div class="input-statement">Malaika.resume</div>
                          <div class="return-statement">"<a href="/static/assets/img/mk-resume.pdf" target="_blank">malaikakunle.pdf</a>"</div>
                        </div>
                        <div class="statement">
                          <div class="input-statement">Malaika.interests</div>
                          <div class="return-statement">["board games", "corgis", "music", "podcasts", "stardew valley"]</div>
                        </div>
                        <div class="statement">
                          <div class="input-statement">Malaika.education</div>
                          <div class="return-statement">"B.Sc. Computational Mathematics - University of South Florida, Tampa, FL"</div>
                        </div>
                        <div class="statement">
                          <div class="input-statement">Malaika.skills.frontend</div>
                          <div class="return-statement">["TypeScript", "JavaScript", "VueJs", "ReactJS", "Angular", "HTML5", "CSS3", "SASS", "Bootstrap", "Vuetify", "NextJs", "React Native"]</div>
                        </div>
                        <div class="statement">
                          <div class="input-statement">Malaika.skills.backend</div>
                          <div class="return-statement">["NodeJS", "Express", "ASP.NET", "REST APIs", "PostgreSQL", "MongoDB", "MySQL", "SQL"]</div>
                        </div>
                        <div class="statement">
                          <div class="input-statement">Malaika.skills.tools</div>
                          <div class="return-statement">["Git", "CI/CD", "Jest", "Linux", "Agile/Scrum", "Postman", "Webpack"]</div>
                        </div>
                        <div class="statement">
                            <div class="input-statement"><span class="animate__animated animate__flash animate__infinite">&nbsp;</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            <div class="container">
			<div class="row center">
				<div class="col-md-12">

					<div class="km-space"></div>
					<h5 class="lead">I consider work an ongoing education and am always looking for opportunities to grow alongside people who love what they build. Whether it's architecting a backend system or refining a UI, I bring the same rigor and curiosity to every layer of the stack.</h5>
				</div>
			</div><!-- description text -->

		</div>
	</section>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      msg: ""
    };
  }
};
</script>

<style>
.hero-description {
  font-family: sans-serif;
  font-weight: 200;
  font-size: 1.3em;
  line-height: 22px;
}

.hero-container .hero-description {
  font-family: sans-serif;
  font-weight: 200;
  font-size: 1.3em;
  padding-top: 20px;
  padding-left: 50px;
  padding-right: 50px;
  line-height: 40px;
  color: #242424;
  margin: 8px 0;
  transition: all 0.5s ease;
}
.about-container .terminal .terminal-window a {
  position: relative;
  text-decoration: none;
  color: #35feff;
}
.about-container {
  width: 90%;
  margin-top: 20vh;
  margin: 0 auto;
}
.about-container .terminal .terminal-window .statement:last-child {
  padding-bottom: 60px;
}

.about-container .terminal .terminal-header {
  height: 28px;
  background-color: #e4e3e5;
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.about-container .terminal .terminal-header .red {
  background-color: #f96256;
  border: 1px solid #f65549;
}
.about-container .terminal .terminal-header .header-button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-left: 9px;
}

.about-container .terminal .terminal-header .yellow {
  background-color: #fdbc3d;
  border: 1px solid #ffb524;
}

.about-container .terminal .terminal-window .statement .input-statement:before {
  content: ">\A0";
}
.about-container .terminal .terminal-window .statement span {
  background: hsla(0, 0%, 97%, 0.65);
}

.about-container .terminal .terminal-header .header-button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-left: 9px;
}

.about-container .terminal .terminal-header .green {
  background-color: #33c948;
  border: 1px solid #2dbb41;
}

.about-container .terminal .terminal-header .header-button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-left: 9px;
}

.about-container .terminal .terminal-window .statement:first-child {
  padding-top: 35px;
}

.about-container .terminal .terminal-window {
  background-color: #181923;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 50px 100px rgba(50, 50, 93, 0.15),
    0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.12);
  font-family: Monaco, Consolas, Lucida Console, monospace;
}

.about-container .terminal .terminal-window .statement .input-statement {
  color: #f7f7f7;
}

.about-container .terminal .terminal-window .statement {
  margin-bottom: 25px;
  margin-left: 35px;
  margin-right: 35px;
  line-height: 24px;
}

.about-container .terminal .terminal-window .statement .return-statement {
  color: #e7d184;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue